// import React from "react";

// export default function Form() {
//     const handleSubmit = (event) => {
//         event.preventDefault();
//         const form = event.target;
        
//         // Create a hidden input field
//         const accessKeyInput = document.createElement("input");
//         accessKeyInput.type = "hidden";
//         accessKeyInput.name = "access_key";
//         accessKeyInput.value = "564d237b-e3e3-4ca6-91e7-795738ac51e8";
        
//         // Append the hidden input field to the form
//         form.appendChild(accessKeyInput);

//         // Submit the form
//         form.submit();
//     };


//     const _handleKeyPress =(e)=>{
//         console.log("_handleKeyPress",e.which,e.KeyCode);
        
//         var key=e.which || e.KeyCode;
//         if (key > 31 && (key < 48 || key > 57)) {
//             e.preventDefault();
//           }
//     }

//     return (
//         <div className="form">
//             <form action="https://api.web3forms.com/submit" method="POST" onSubmit={handleSubmit}>
//                 <label>Name*</label><br/>
//                 <input className="input-field" type="text" name="name" id="name" placeholder="Enter your name" required/><br />
//                 <label>Phone Number*</label><br/>
//                 <input className="input-field" type="text" name="phoneNumber" id="number" placeholder="Enter your phone number" pattern="[0-9]{10}" required onKeyPress={(e)=>_handleKeyPress(e)}/><br />
//                 <label>Email Id*</label><br/>
//                 <input className="input-field" type="email" name="email" id="email" placeholder="Enter your email id" required/><br />
//                 <label>Message</label><br/>
//                 <textarea className="input-field" name="text" id="text-area" cols="40" rows="10" placeholder="Leave us a message"></textarea><br />
//                 <button className="submit" type="submit">Submit</button>
//             </form>
//         </div>
//     );
// }
import React from "react";

export default function Form() {
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;

        const accessKeyInput = document.createElement("input");
        accessKeyInput.type = "hidden";
        accessKeyInput.name = "access_key";
        accessKeyInput.value = "564d237b-e3e3-4ca6-91e7-795738ac51e8";

        form.appendChild(accessKeyInput);
        form.submit();
    };

    const _handleKeyDown = (e) => {
        const key = e.key; // Use e.key
        if (isNaN(parseInt(key)) && key !== 'Backspace' && key !== 'Tab' && key !== 'Delete' && key !== 'ArrowLeft' && key !== 'ArrowRight') {
            e.preventDefault();
        }
    };

    return (
        <div className="form">
            <form action="https://api.web3forms.com/submit" method="POST" onSubmit={handleSubmit}>
                <label>Name*</label><br />
                <input className="input-field" type="text" name="name" id="name" placeholder="Enter your name" required /><br />
                <label>Phone Number*</label><br />
                <input className="input-field" type="text" name="phoneNumber" id="number" placeholder="Enter your phone number" pattern="[0-9]{10}" required onKeyDown={_handleKeyDown} /><br />
                <label>Email Id*</label><br />
                <input className="input-field" type="email" name="email" id="email" placeholder="Enter your email id" required /><br />
                <label>Message</label><br />
                <textarea className="input-field" name="text" id="text-area" cols="40" rows="10" placeholder="Leave us a message"></textarea><br />
                <button className="submit" type="submit">Submit</button>
            </form>
        </div>
    );
}